import React, {memo} from 'react';
import {Theme} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import FolderIcon from 'components/icons/FolderIcon';
import classnames from 'classnames';
import Button from 'components/Button';

const useStyles = makeStyles((theme: Theme) => ({
   root: {
      textTransform: 'none',
      wordBreak: 'break-all',
   },
   selected: {
      backgroundColor: theme.palette.grey[300],
      '&:hover': {
         backgroundColor: theme.palette.grey[300],
      },
   },
}));

type FileFolderProps = {
   name: string;
   selected: boolean;
   onClick: () => void;
   onDoubleClick: () => void;
};

const FolderItem = memo(({onClick, onDoubleClick, name: _name, selected}: FileFolderProps) => {
   const classes = useStyles();
   const name = _name; //truncate(_name, {length: 20});

   return (
      <Button
         variant={'text'}
         disableElevation
         disableRipple
         title={_name}
         className={classnames(classes.root, {[classes.selected]: selected})}
         onClick={onClick}
         onDoubleClick={onDoubleClick}
         startIcon={<FolderIcon />}
      >
         {name}
      </Button>
   );
});

export default FolderItem;
